<template>
  <div>
    <Event @openOverlay="overLay" />
    <SosSlider :overLay="overLay" :animateOverlay="animateOverlay" />
  </div>
</template>

<script>
import Event from "../components/event/Event";
import SosSlider from "@/components/SosSlider.vue";

export default {
  props: ["id"],
  components: { Event, SosSlider },

  data() {
    return {
      animateOverlay: false
    };
  },
  methods: {
    overLay() {
      this.animateOverlay = !this.animateOverlay;
    }
  },
  mounted() {
    if (this.$store.state.events.prediction == null) {
      this.$store.dispatch("events/getPrediction", this.id);
    } else if (this.$store.state.events.prediction._id !== this.id) {
      this.$store.dispatch("events/clearPrediction");
      this.$store.dispatch("events/getPrediction", this.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
